module.exports = __webpack_public_path__ + "assets/d8f60efc8484d0348ff7331a14651b75.png";